import React, { useEffect } from 'react';
import { META_PIXEL_ID } from './data/kit';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { InsideSection } from './components/InsideSection';
import { SamplesSection } from './components/SamplesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeFaqSection } from './components/GuaranteeFaqSection';
import { FinalSection } from './components/FinalSection';
export function App() {
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
  }, []);
  return <div className="w-full" style={{
    background: 'var(--night)'
  }} data-id="element-0" data-mp="2whx8rm2ytac0">
      <a className="skip-link" href="#main" data-id="element-1" data-mp="28t4lee0esat0">
        Skip to content
      </a>
      <main id="main" data-id="element-2" data-mp="23w4gi6fape3h">
        <Hero data-id="element-3" data-mp="23ujl6el5pr4k" />
        <ProblemSection data-id="element-4" data-mp="23v2sz2h3ez4v" />
        <SolutionSection data-id="element-5" data-mp="3ijxpqrsp22kf" />
        <InsideSection data-id="element-6" data-mp="3ikh5q2ysagvt" />
        <SamplesSection data-id="element-7" data-mp="3ij668fcdfvai" />
        <BonusesSection data-id="element-8" data-mp="3ihv2gfixenje" />
        <OfferSection data-id="element-9" data-mp="3mlj6io8cn0zw" />
        <GuaranteeFaqSection data-id="element-10" data-mp="3mkrbpfmkt7ao" />
        <FinalSection data-id="element-11" data-mp="3mjztr7lwj82v" />
      </main>
    </div>;
}